<template>
    <form v-on:submit.prevent>
        <h3>Module Info</h3>
        <div class="row">
            <div class="column">
                <label>Name</label>
                <input type="text" v-model="module.name">
                
                <label>Price ($)</label>
                <input type="number" step="0.01" v-model="module.price">

                <label>Number of Lockers (Inc. Kiosk)</label>
                <input type="number" v-model="module.num_lockers">

                <label>Is Kiosk</label>
                <input type="checkbox" v-model="module.is_kiosk">
            </div>

            <div class="column">
                <label>Height (mm)</label>
                <input type="number" v-model="module.height"/>

                <label>Width (mm)</label>
                <input type="number" v-model="module.width"/>

                <label>Depth (mm)</label>
                <input type="number" v-model="module.depth"/>
            </div>
        </div>
        
        <p><button @click="saveModule">Save</button></p>
    </form>
</template>

<script>
    import {CallApi} from '../Utilities.js'

    export default {
        name: 'ModuleCreate',
        data: function() {
            return {
                module: {
                    name: '',
                    price: 0,
                    height: 0,
                    depth: 0,
                    width: 0,
                    is_kiosk: 0,
                    num_lockers: 0,
                }
            }
        },
        methods: {
            saveModule: async function() {
                // Post to Server
                const apiResult = await CallApi('POST', '/modules', this.module)
                
                // Redirect to New Module
                if (apiResult.module) {
                    this.$router.push(`/lockermodules/${apiResult.module.id}`)
                }
            }
        }
    }
</script>

